module.exports = __webpack_public_path__ + "static/img/jingong.c5cc8d5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/test/jingong.jpg
// module id = cIEJ
// module chunks = 1